{
  "mine": {
    "title": "My courses",
    "subtitle": "The courses you are enrolled in, and how far along you are.",
    "empty": "You are not enrolled in any course yet.",
    "resume": "Resume",
    "review": "Review"
  },
  "player": {
    "loading": "Loading course",
    "curriculum": "Curriculum",
    "progress": "{{done}} of {{total}} lessons completed — {{percent}}%",
    "progressLabel": "Course progress",
    "markRead": "I have read this lesson",
    "courseCompleted": "You have completed this course. Well done!",
    "notEnrolledTitle": "Enrol to follow this course",
    "notEnrolledBody": "Enrolling opens the lessons and records your progress.",
    "enrol": "Enrol in this course"
  },
  "state": {
    "locked": "Locked",
    "available": "Available",
    "in_progress": "In progress",
    "completed": "Completed"
  },
  "lockReason": {
    "exercise_not_passed": "Pass the exercise in the previous lesson to unlock this one.",
    "awaiting_grading": "Your previous paper is waiting to be graded by the teacher."
  },
  "attempt": {
    "start": "Start the exercise",
    "submit": "Hand in my paper",
    "retry": "New attempt",
    "resultTitle": "Result",
    "passed": "Exercise passed.",
    "failed": "Exercise not passed.",
    "awaitingGrading": "Your paper has been handed in. It is waiting for the teacher to grade it.",
    "passMark": "Pass mark",
    "attemptsLeft": "Attempts left",
    "bestScore": "Best score",
    "unlimited": "Unlimited",
    "percent": "{{value}}%"
  },
  "dashboard": {
    "title": "My dashboard",
    "subtitle": "Where you are, what is pending, and your latest results.",
    "inProgress": "Courses in progress",
    "awaiting": "Awaiting grading",
    "awaitingEmpty": "No paper is waiting to be graded.",
    "awaitingItem": "Your paper for “{{course}}” is waiting for the teacher to grade it.",
    "awaitingBlocking": "Your paper for “{{course}}” is waiting to be graded. The rest of the course stays closed until then.",
    "recent": "Latest results",
    "recentEmpty": "No result yet.",
    "noScore": "Not scored"
  },
  "grading": {
    "title": "Papers to grade",
    "subtitle": "Papers handed in by your learners, oldest first.",
    "empty": "No paper is waiting for you.",
    "open": "Grade",
    "attemptNumber": "Attempt #{{number}}",
    "blocking": "Blocks the rest of the course for this learner.",
    "by": "{{student}} — {{course}} — attempt #{{number}}",
    "instructions": "Instructions",
    "studentAnswer": "Learner's answer",
    "blank": "No answer",
    "autoGraded": "Graded automatically. You may override the mark.",
    "manualQuestion": "Open question: a mark is required.",
    "points": "Points (out of {{max}})",
    "answerFeedback": "Comment on this answer",
    "overallFeedback": "Overall feedback",
    "submit": "Save the grading",
    "gradedScore": "{{score}} / {{max}} — {{percent}}%",
    "revoke": "Revoke this grading",
    "confirmRevoke": "Revoke this grading? The learner will lose the mark they have read, and the next lesson may close again. The grading stays in the history.",
    "history": "Grading history",
    "currentGrade": "current mark",
    "unknownGrader": "Unknown grader"
  },
  "teaching": {
    "title": "Dashboard",
    "subtitle": "Your learners, your courses, and what needs your attention.",
    "students": "Enrolments",
    "activeStudents": "Active (7 days)",
    "pending": "Papers to grade",
    "openQueue": "Open the queue",
    "courses": "My courses",
    "noCourse": "You have no course yet.",
    "draft": "draft",
    "courseStats": "{{students}} enrolled — {{progress}}% average progress — {{completion}}% completed, {{drop}}% dropped",
    "struggling": "Learners needing attention",
    "strugglingEmpty": "No learner needs your attention.",
    "reasonInactive": "No activity for over 14 days on “{{course}}”.",
    "reasonFailures": "{{attempts}} failures on “{{exercise}}”, still not passed.",
    "openStudent": "Open the file",
    "weakest": "Least-passed exercises",
    "weakestEmpty": "Not enough papers yet to read a signal.",
    "passRate": "{{rate}}% ({{passed}}/{{total}})"
  },
  "student": {
    "title": "Learner file",
    "subtitle": "Their progress in your courses, and what they agreed to share.",
    "myCourses": "In my courses",
    "results": "Latest results",
    "otherCourses": "Their other courses",
    "otherCoursesEmpty": "They follow no other course.",
    "consentRequired": "This learner has not agreed to share their progress outside your courses. You may ask them for it."
  },
  "certificates": {
    "title": "My certificates",
    "subtitle": "Certificates for the courses you have completed. The verification number lets anyone confirm they are genuine, without an account.",
    "empty": "You have no certificate yet. Complete a course to earn one.",
    "issuedOn": "Issued on",
    "serial": "Verification number",
    "download": "Download the PDF",
    "shareHint": "Have this certificate verified at",
    "revoked": "This certificate was withdrawn on {{date}}.",
    "nav": "My certificates"
  },
  "verify": {
    "title": "Verify a certificate",
    "subtitle": "Enter the number printed on the certificate to confirm it is genuine. No account is required.",
    "serialLabel": "Verification number",
    "serialHint": "Dashes and letter case do not matter.",
    "submit": "Verify",
    "valid": "This certificate is genuine.",
    "revoked": "This certificate was withdrawn on {{date}} and is no longer valid.",
    "unknown": "No certificate matches this number.",
    "holder": "Holder"
  }
}
